export  const SidebarMenu = [
    {
      label: 'Dashboard',
      routerLink: './dashboard',
      iconType: 'fa',
      iconName: 'home',
    },
    {
      label: 'Organizations',
      routerLink: './organisation',
      iconType: 'fa',
      iconName: 'building',
    },
    {
      label: 'Organization-LRS',
      routerLink: './lrs',
      iconType: 'fa',
      iconName: 'usb',
    },
    {
      label: 'Roles',
      routerLink: './role',
      iconType: 'fa',
      iconName: 'user-secret fa-fw',
    },
    {
      label: 'Users',
      routerLink: './user',
      iconType: 'fa',
      iconName: 'user',
    },
    {
      label: 'Courses',
      // details: "12 New Updates",
      routerLink: './course',
      iconType: 'fa',
      iconName: 'book',
    },
    // {
    //   label: 'Topics',
    //   routerLink: './topic',
    //   iconType: 'fa',
    //   iconName: 'newspaper-o',
    // },
    // {
    //   label: 'Sections',
    //   routerLink: './section',
    //   iconType: 'fa',
    //   iconName: 'pie-chart',
    // },
  ];



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/assets/objects/sidebar-menu.ts